import { FormProvider } from "react-hook-form";
import { FiX } from "react-icons/fi";
import DashboardStyle from "../../../../../dashboard/Styles/Dashboard.module.css";
import { useGetSingleKeyResultAreaQuery } from "../../../../../api/hrApi";
import { FormTemplate } from "../../../../Components/Forms/InputTemplate";
import { FormatDateTime } from "../../../../../../utils/functions/ResourceFunctions";
import {
  appraisalPeriodFormatter,
  crossReviewTypeFormatter,
  MeasurementTypeFormatter,
} from "./data";
const ObjectiveKraViewModal = ({ isOpen, setIsOpen, id }) => {
  const { data } = useGetSingleKeyResultAreaQuery(id); 
  const renderBooleanBadge = (value) => (
    <span
      style={{
        display: "inline-flex",
        alignItems: "center",
        padding: "4px 8px",
        borderRadius: "12px",
        fontSize: "12px",
        fontWeight: "500",
        backgroundColor: value ? "#dcfce7" : "#f3f4f6",
        color: value ? "#166534" : "#374151",
        border: `1px solid ${value ? "#bbf7d0" : "#d1d5db"}`,
      }}
    >
      {value ? "Yes" : "No"}
    </span>
  );
  return (
    <div className={DashboardStyle.dash_board_home_nav}>
      <div className={DashboardStyle.dash_board_home_nav_header}>
        <div>
          <h1 className="text-[28px] font-[800]">KRA DETAILS</h1>
          <p>Define and manage objectives and kra setup.</p>
        </div>
        <FiX
          style={{ cursor: "pointer" }}
          size={"1.5rem"}
          onClick={() => setIsOpen(!isOpen)}
        />
      </div>
      <div className={DashboardStyle.dash_board_home_nav_body}>
        <div>
          <div>
            <FormProvider>
              <FormTemplate>
                <div className="w-full space-y-7">
                  <section
                    style={{
                      backgroundColor: "#F8FBF8",
                      border: "1px solid #D9E9DA",
                      borderRadius: "8px",
                    }}
                    className={DashboardStyle.form_section}
                  >
                    <h4 className={DashboardStyle.form_section_title}>
                      Process <br /> Information
                    </h4>
                    <div className={DashboardStyle.labels_group}>
                      <div
                        style={{
                          display: "grid",
                          gridTemplateColumns:
                            "repeat(auto-fill, minmax(32.3%, 1fr))",
                          gap: "10px",
                        }}
                      >
                        <div>
                          <p>Title:</p>
                          <h4>{data?.responseObject?.title}</h4>
                        </div>
                        <div>
                          <p>Description:</p>
                          <h4>{data?.responseObject?.description}</h4>
                        </div>
                        <div>
                          <p>Is AutoGenerated Source: </p>
                          <h4>{data?.responseObject?.isAutoGenerated ? "Yes" : "No"}</h4>
                        </div>
                      {data?.responseObject?.isAutoGenerated &&  <div>
                          <p>AutoGenerated Source:</p>
                          <h4>{data?.responseObject?.autoGeneratedSource}</h4>
                        </div>}
                        <div>
                          <p>Target Value:</p>
                          <h4>{data?.responseObject?.targetValue}</h4>
                        </div>
                        {/* <div>
                          <p>Currency Type:</p>
                          <h4>{data?.responseObject?.currencyType}</h4>
                        </div> */}
                        <div>
                          <p>Target Value:</p>
                          <h4>{data?.responseObject?.targetValue}</h4>
                        </div>
                        <div>
                          <p>Period Start Date:</p>
                          <h4>
                            {FormatDateTime(
                              data?.responseObject?.periodStartDate,
                              "DD/MM/YYYY"
                            )}
                          </h4>
                        </div>
                        <div>
                          <p>Period End Date:</p>
                          <h4>
                            {FormatDateTime(
                              data?.responseObject?.periodEndDate,
                              "DD/MM/YYYY"
                            )}
                          </h4>
                        </div>
                        <div>
                          <p>Cross Review Type:</p>
                          <h4>
                            {crossReviewTypeFormatter(
                              data?.responseObject?.crossReviewType
                            )}
                          </h4>
                        </div>
                        <div>
                          <p>Appraisal Period:</p>
                          <h4>
                            {appraisalPeriodFormatter(
                              data?.responseObject?.appraisalPeriod
                            )}
                          </h4>
                        </div>
                        <div>
                          <p>Measurement Type:</p>
                          <h4>
                            {MeasurementTypeFormatter(
                              data?.responseObject?.measurementType
                            )}
                          </h4>
                        </div>
                        <div>
                          <p>KRA Type:</p>
                          <h4>
                            {data?.responseObject?.type === 1
                              ? "Core"
                              : "Non-Core"}
                          </h4>
                        </div>
                        <div>
                          <p>isFloatable:</p>
                          <h4>
                            {renderBooleanBadge(
                              data?.responseObject?.isFloatable
                            )}
                          </h4>
                        </div>
                        <div>
                          <p>isAutoGenerated:</p>
                          <h4>
                            {renderBooleanBadge(
                              data?.responseObject?.isAutoGenerated
                            )}
                          </h4>
                        </div>
                        <div>
                          <p>is360Applicable:</p>
                          <h4>
                            {renderBooleanBadge(
                              data?.responseObject?.is360Applicable
                            )}
                          </h4>
                        </div>
                        <div>
                          <p>includePeerReview:</p>
                          <h4>
                            {renderBooleanBadge(
                              data?.responseObject?.includePeerReview
                            )}
                          </h4>
                        </div>
                        <div>
                          <p>peerReviewAffectsScore:</p>
                          <h4>
                            {renderBooleanBadge(
                              data?.responseObject?.peerReviewAffectsScore
                            )}
                          </h4>
                        </div>
                        <div>
                          <p>includeUpwardReview:</p>
                          <h4>
                            {renderBooleanBadge(
                              data?.responseObject?.includeUpwardReview
                            )}
                          </h4>
                        </div>
                        <div>
                          <p>upwardReviewAffectsScore:</p>
                          <h4>
                            {renderBooleanBadge(
                              data?.responseObject?.upwardReviewAffectsScore
                            )}
                          </h4>
                        </div>
                        <div>
                          <p>includeCrossReview:</p>
                          <h4>
                            {renderBooleanBadge(
                              data?.responseObject?.includeCrossReview
                            )}
                          </h4>
                        </div>
                        <div>
                          <p>crossReviewAffectsScore:</p>
                          <h4>
                            {renderBooleanBadge(
                              data?.responseObject?.crossReviewAffectsScore
                            )}
                          </h4>
                        </div>

                        <div>
                          <p>includeLineManagerReview:</p>
                          <h4>
                            {renderBooleanBadge(
                              data?.responseObject?.includeLineManagerReview
                            )}
                          </h4>
                        </div>
                        <div>
                          <p>slaReminderCount:</p>
                          <h4>{data?.responseObject?.slaReminderCount}</h4>
                        </div>
                        <div>
                          <p>includeSelfReview:</p>
                          <h4>
                            {renderBooleanBadge(
                              data?.responseObject?.includeSelfReview
                            )}
                          </h4>
                        </div>
                      </div>
                    </div>
                  </section>
                </div>
              </FormTemplate>
            </FormProvider>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ObjectiveKraViewModal;
